import { USER_LANGUAGE_PROMPT } from "../constants/ai.constants";
import { SEC_STACK_GOV_RES_NO_PROMPT, SEC_STACK_GOV_RES_PARTNER_PROMPT, SEC_STACK_GOV_RES_PROMPT, SEC_STACK_GOV_RES_UNDER_REVIEW_PROMPT, SEC_STACK_GOV_RES_YES_PROMPT, SEC_STACK_NO_GENERATE_PROMPT } from "../constants/security-stack.constants";

const getSecStackNoGeneratePrompt = (toolType, toolName, language) => {
  const toolTypeString = toolType == 1 ? 'Practice' : 'Technology';
  const languagePrompt = USER_LANGUAGE_PROMPT.replace('[language]', language);
  return `${SEC_STACK_NO_GENERATE_PROMPT.replace('[ToolType]', toolTypeString).replace('[ToolName]', toolName)}. \n${languagePrompt}`;
}

const getSecStackGovResPrompt = (question, promptType, language) => {
  const basicPrompt = SEC_STACK_GOV_RES_PROMPT;
  let additionalPrompt = '';
  switch (promptType) {
    case 'Yes':
      additionalPrompt = SEC_STACK_GOV_RES_YES_PROMPT;
      break;
    case 'No':
      additionalPrompt = SEC_STACK_GOV_RES_NO_PROMPT;
      break;
    case 'Under Review':
      additionalPrompt = SEC_STACK_GOV_RES_UNDER_REVIEW_PROMPT;
      break;
    case 'Partner':
      additionalPrompt = SEC_STACK_GOV_RES_PARTNER_PROMPT;
      break;
    default:
      break;
  }
  const languagePrompt = USER_LANGUAGE_PROMPT.replace('[language]', language);
  return `${basicPrompt} ${additionalPrompt} \n${languagePrompt}`.replace('[Question]', question);
}

const securityStackUtils = {
  getSecStackNoGeneratePrompt,
  getSecStackGovResPrompt
}

export default securityStackUtils;
